module.exports = __webpack_public_path__ + "static/media/c105_cd3.72093ba3.jpeg";